/** Stable identity used by the read-only virtual navigation folder. */
export const UNCATEGORIZED_FOLDER_ID = '__uncategorized__';

/**
 * Projects the current workspace's document list into the virtual
 * Uncategorized folder. The input order is retained and duplicate IDs are
 * removed so a malformed/duplicated document list cannot render a row twice.
 */
export function getUncategorizedDocumentIds(
  documentIds: readonly string[],
  linkedDocumentIds: readonly string[]
): string[] {
  const linked = new Set(linkedDocumentIds);
  const seen = new Set<string>();
  const result: string[] = [];

  for (const id of documentIds) {
    if (!id || linked.has(id) || seen.has(id)) {
      continue;
    }
    seen.add(id);
    result.push(id);
  }

  return result;
}
